module.exports = __webpack_public_path__ + "static/media/downArrow.4441401a.svg";